module.exports = __webpack_public_path__ + "screenshot.9841f8eb06368e660e632894a3143b8b.png";